"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
function default_1({ control, bankList, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "bank_name", rules: { required: t('은행을 선택해주세요') }, render: ({ field }) => ((0, jsx_runtime_1.jsxs)(components_1.NativeSelect, Object.assign({ value: field.value, onChange: e => field.onChange(e.target.value), sx: {
                    '@media (max-width: 430px)': { width: '120px' },
                    height: '48px',
                    p: '0 12px',
                    border: '1px solid rgba(0, 0, 0, 0.1) !important',
                    borderRadius: '8px',
                    lineHeight: '16px',
                    fontSize: '15px',
                    cursor: 'unset',
                    '.MuiNativeSelect-icon': { right: '8px', width: '24px', height: '24px' },
                } }, { children: [(0, jsx_runtime_1.jsx)("option", Object.assign({ value: "", disabled: true }, { children: t('은행 선택') })), bankList.map((bankName, idx) => ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: bankName }, { children: bankName }), `refund_bank_code_${bankName}_${idx}`)))] }))) }) }));
}
exports.default = default_1;
